"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Iban = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var ComposedTypo_1 = require("../ComposedTypo");

var titleDefaultProps = {
  variant: 'h2',
  weight: 'bold'
};
var textDefaultProps = {
  variant: 'body',
  weight: 'medium'
};

exports.Iban = function (_a) {
  var titulaire = _a.titulaire,
      iban = _a.iban,
      loaderSubmit = _a.loaderSubmit,
      messageError = _a.messageError,
      onClick = _a.onClick,
      callPostIban = _a.callPostIban,
      _b = _a.showTitulaire,
      showTitulaire = _b === void 0 ? false : _b,
      _c = _a.modeOfPayment,
      modeOfPayment = _c === void 0 ? "paymentEtip" : _c;
  return react_1.default.createElement(react_1.default.Fragment, null, showTitulaire && react_1.default.createElement("div", {
    className: "row"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    weight: "bold",
    className: "col-12"
  }, "Coordonn\xE9es bancaires")), react_1.default.createElement("div", {
    className: "row mb-4"
  }, showTitulaire && react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "cy-titulaire col-md-3 mb-3 mb-md-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, __assign({}, titleDefaultProps), "Titulaire"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, __assign({}, textDefaultProps), titulaire)), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "cy-iban col-md-6 mb-3 mb-md-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, __assign({}, titleDefaultProps), "IBAN"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, __assign({}, textDefaultProps), iban)), react_1.default.createElement("div", {
    className: "mr-3 col-md-2"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    className: "cy-btn-update-iban px-1 px-md-3",
    icon: "pencil-write",
    onClick: onClick
  }, "Modifier"))), messageError && react_1.default.createElement("div", {
    className: "row",
    style: {
      marginLeft: '-5.5rem',
      marginRight: '-5.5rem',
      background: 'var(--gray-0)',
      padding: '1rem 5.5rem'
    }
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger",
    className: "col-12 mb-0 bg-transparent"
  }, messageError)), showTitulaire && react_1.default.createElement("div", {
    className: "row position-relative justify-content-between",
    style: {
      marginLeft: '-5.5rem',
      marginRight: '-5.5rem',
      background: 'var(--gray-0)',
      padding: '1rem 5.5rem'
    }
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    loader: loaderSubmit,
    className: "cy-btn-valid-submit iban-btn_submit col-7 col-md-3 ml-auto",
    onClick: callPostIban
  }, "Valider le pr\xE9l\xE8vement")));
};

exports.default = exports.Iban;